// extracted by mini-css-extract-plugin
export var Link___icon = "link-module--Link___icon--2e584";
export var slideIn = "link-module--slide-in--51169";
export var slideInFromRight = "link-module--slide-in-from-right--c0eae";